/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：781
 */

"use strict"

function r(e, t) {
  return (r = Object.setPrototypeOf || function (e, t) {
    e.__proto__ = t
    return e
  })(e, t)
}
export { r as a }
export default r
